import React from 'react';

const SvgElectro: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="-4 -4 24 24"
    {...props}
  >
    <path
      fill="#5A636B"
      d="M2.24 14c-.347 0-.64-.12-.88-.36S1 13.107 1 12.76V5.64c0-.347.12-.64.36-.88s.533-.36.88-.36h2.874V3.24c0-.347.12-.64.36-.88s.533-.36.88-.36h2.32c.347 0 .64.12.88.36s.36.533.36.88V4.4h2.875c.346 0 .64.12.88.36s.36.533.36.88v7.12c0 .347-.12.64-.36.88s-.534.36-.88.36H2.239Zm3.903-9.6h2.743V3.24a.201.201 0 0 0-.066-.145.201.201 0 0 0-.145-.066H6.354a.201.201 0 0 0-.145.066.201.201 0 0 0-.066.145V4.4Zm1.371 6c.333 0 .617-.117.85-.35.234-.234.35-.517.35-.85 0-.333-.116-.616-.35-.85a1.158 1.158 0 0 0-.85-.35c-.333 0-.616.117-.85.35-.233.234-.35.517-.35.85 0 .333.117.616.35.85.234.233.517.35.85.35Z" // eslint-disable-line max-len
    />
  </svg>
);

export default SvgElectro;
